module.exports = __webpack_public_path__ + "static/img/software_icon1.6af2ab8b.png";